export default "__VITE_ASSET__CnNp1Evj__"